import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const AdminDisableDataCollection = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Your administrator has chosen to opt out of data collection.
    </Color>
  </Paragraph>

export default AdminDisableDataCollection
